import util from '@/libs/util'

const post = util.ajax.post

export const certificatemainUrls = [
  // 查询尾气检测列表
  '/order/finishlist'
]

export const certificatemain = {}

certificatemain.listOrder = function (params) {
  return post('/order/finishlist', params)
}
certificatemain.updatePrinted = function (params) {
  return post('/order/updateOrderPrintStatus', params)
}



// WEBPACK FOOTER //
// ./src/api/gip/certificate/certificatemain.js